module.exports = __webpack_public_path__ + "img/Icon_Download.f5a634ad.svg";